<template>
    <div>
        <textarea
        v-model="value2"
        :placeholder="label"
        :cols="cols"
        :rows="rows"
        :disabled="disabled"
        :change="change"
        ></textarea>
        <div><span v-for="item in errorMsgs">{{item}}</span></div>
    </div>
</template>

<script>
    import InputBase from './InputBase';
    export default {
        mixins: [InputBase],
        props: ['appendIcon', 'appendIconCb','autoGrow',"rows", "cols", "change", "disabled"],
        data(){
            return{
                value2: null
            };
        },
         created: () => {
            this.value2 = this.value;
        },
        watch:{
            value2(v){
                this.emit(v);
                this.touch();
            },
            value: {
                handler(va, old) {
                    if(va === this.value2) return;
                    this.value2 = va;
                },
                immediate: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/public_app/elements/Textarea.vue